import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ChatGPTService extends ServiceBase {

    constructor(private http: HttpClient,
        authService: AuthService) {
        super(authService);
    }

    public generateSuggestion(request: ChatGPTContentGenerationRequest): Observable<ChatGPTGeneratedProductDescriptionsResponse> {
        const httpOptions = this.RequestHeaders();
        const api: string = '/chatgpt';
        const method: string = '/product-descriptions';
        var url = environment.BASE_API_PATH + api + method;
        return this.http.post<ChatGPTGeneratedProductDescriptionsResponse>(url, request, httpOptions);
    }

    public generateGalleryProducutDescriptions(request: ChatGPTGenerationGalleryDescriptions): Observable<ChatGPTGeneratedProductDescriptionsResponse> {
        const httpOptions = this.RequestHeaders();
        const api: string = '/chatgpt';
        const method: string = '/gallery-product-descriptions';
        var url = environment.BASE_API_PATH + api + method;
        return this.http.post<ChatGPTGeneratedProductDescriptionsResponse>(url, request, httpOptions);
    }

    public generateAiDescription(request: ChatGPTAIDescription): Observable<ResponseObject> {
        const httpOptions = this.RequestHeaders();
        const api: string = '/chatgpt';
        const method: string = '/descriptionFor-series-features-materials';
        var url = environment.BASE_API_PATH + api + method;
        const requestBody = {
            descriptionFor: request.descriptionFor,
            artType: request.artType,
            name: request.name,
            useChatGPTAIEngine: request.useChatGPTAIEngine,
        };
        return this.http.post<ResponseObject>(url, requestBody, httpOptions);
    }
}

export class ChatGPTContentGenerationRequest {
    public ArtistProductId!: string;
    public IncludeProductSeries?: boolean;
    public IncludeProductFeatures?: boolean;
    public IncludeProductMaterial?: boolean;
    public IncludeProductCoverPhoto?: boolean;
    public IncludeArtistProfile?: boolean;
    public Tone?: string;
    public HintContent?: string;
    public UseChatGPTAIEngine: boolean = true; 
}
export class ChatGPTGenerationGalleryDescriptions {
    public ProductId!: string;
    public IncludeProductCoverPhoto?: boolean;
    public IncludeGalleryProfile?: boolean;
    public Tone?: string;
    public HintContent?: string;
    public UseChatGPTAIEngine!: boolean;
}

export class ChatGPTGeneratedProductDescriptionsResponse {
    Success!: boolean;
    ErrorMessage?: string;
    ShortDescription?: string;
    MarketingDescription?: string;
    SocialMediaPostDescription?: string;
}

export class ChatGPTAIDescription {
    descriptionFor!: string;
    artType!: string | undefined;
    name!: string | undefined;
    useChatGPTAIEngine!: boolean;
}